export default "__VITE_ASSET__QRne8$DF__"